/**
 * Checks in current user account status is active.
 * @param {String} status - User account status.
 */
export function isUserAccountActive(status) {
  return status && status.toLowerCase() === "active";
}

/**
 * Checks in current user account status is prospect.
 * @param {String} status - User account status.
 */
export function isUserAccountProspect(status) {
  return status.toLowerCase() === "prospect";
}
